<template>
  <component
    :is="tag"
    v-b-tooltip.lefttop="'管理者のみ表示'"
    class="core-admin-role-only"
  >
    <slot />
  </component>
</template>
<script lang="ts">
export default {
  name: 'AdminRoleOnly',
  description: '管理者 ($core.$embAuth.user.isAdmin) のみ表示',
  props: {
    tag: {
      type: String,
      default: 'span',
      desc: 'span, div, p, etc.',
    },
  },
}
</script>
